import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ items, testId = "faq" }) {
    return (
        <Accordion type="single" collapsible className="mt-10 border-t border-slate-200" data-testid={testId}>
            {items.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-slate-200">
                    <AccordionTrigger className="py-5 text-left text-[15px] font-semibold text-navy hover:no-underline hover:text-brand-red" data-testid={`${testId}-question-${i + 1}`}>
                        <span className="flex items-baseline gap-3">
                            <span className="font-mono text-[11px] font-medium text-brand-red">{String(i + 1).padStart(2, "0")}</span>
                            {f.q}
                        </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 text-[14px] leading-relaxed text-slate-600" data-testid={`${testId}-answer-${i + 1}`}>
                        {f.a}
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );
}
